export const CLEAR_PAYMENT_METHODS = "CLEAR_PAYMENT_METHODS";

export const GET_PAYMENT_METHODS_PROGRESS = "GET_PAYMENT_METHODS_PROGRESS";
export const GET_PAYMENT_METHODS_RECEIVED = "GET_PAYMENT_METHODS_RECEIVED";
export const GET_PAYMENT_METHODS_ERROR = "GET_PAYMENT_METHODS_ERROR";
